import React, { createContext, useCallback, useEffect, useRef } from 'react';
import { bind } from 'bind-event-listener';
import __noop from '@atlaskit/ds-lib/noop';
import handleFocus from '../utiles/handle-focus';

/**
 *
 *
 * Context provider which maintains the list of focusable elements and a method to
 * register new menu items.
 * This list drives the keyboard navgation of the menu.
 *
 */
export var FocusManagerContext = /*#__PURE__*/createContext({
  menuItemRefs: [],
  registerRef: __noop
});

/**
 * Focus manager logic
 */
var FocusManager = function FocusManager(_ref) {
  var children = _ref.children;
  var menuItemRefs = useRef([]);
  var registerRef = useCallback(function (ref) {
    if (ref && !menuItemRefs.current.includes(ref)) {
      menuItemRefs.current.push(ref);
    }
  }, []);

  // set focus and intentionally rebinding listener and clean up listener on each render
  useEffect(function () {
    bind(window, {
      type: 'keydown',
      listener: handleFocus(menuItemRefs.current)
    });
    var unbind = function unbind() {
      bind(window, {
        type: 'keydown',
        listener: handleFocus(menuItemRefs.current)
      });
    };
    return unbind;
  }, []);
  var contextValue = {
    menuItemRefs: menuItemRefs.current,
    registerRef: registerRef
  };
  return /*#__PURE__*/React.createElement(FocusManagerContext.Provider, {
    value: contextValue
  }, children);
};
export default FocusManager;